<template>
<div>
  <Header/>
  <div class="term-and-condition">
    <v-container class="term-and-condition-content">
      <h1>{{$t('terms_and_conditions')}}</h1>
      <p class="main-text">{{$t("about_terms_and_conditions_1")}}</p>
      <div class="page-text">
        {{$t("about_terms_and_conditions_2")}}{{$t("about_terms_and_conditions_3")}}{{$t("about_terms_and_conditions_4")}}
      </div>
      <h2>{{$t("restrictions")}}</h2>
      <div class="page-text">
        <ul>
          <li>{{$t("restrictions_1")}}</li>
          <li>{{$t("restrictions_2")}}</li>
          <li>{{$t("restrictions_3")}}</li>
          <li>{{$t("restrictions_4")}}</li>
          <li>{{$t("restrictions_5")}}</li>
        </ul>
      </div>
      <h2>{{$t("restrictions_on_extual")}}</h2>
      <div class="page-text">
        <ul>
          <li>{{$t("restrictions_on_extual_1")}}</li>
          <li>{{$t("restrictions_on_extual_2")}}</li>
          <li>{{$t("restrictions_on_extual_3")}}</li>
        </ul>
      </div>
    </v-container>
  </div>

</div>
</template>

<script>
import Header from '../components/global/Header.vue'

export default {
  name: 'TermsAndConditionsPage',
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/sass/global/variables";
  .term-and-condition {
    padding: 100px 0;
    height: 100%;
    @media screen and (max-width: $screen-sm) {
      padding: 70px 0;
    }
    .term-and-condition-content {
      margin-top: 76px;
      @media screen and (max-width: $screen-sm) {
        margin-top: 0;
      }
      h1 {
        font-size: 36px;
        line-height: 40px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 40px;
        text-transform: capitalize;
        @media screen and (max-width: $screen-sm) {
          font-size: 26px;
          line-height: 30px;
          margin-bottom: 20px;
        }
      }
    }
    h2 {
      font-size: 26px;
      line-height: 30px;
      font-weight: bold;
      text-align: center;
      margin: 20px 0;
      @media screen and (max-width: $screen-sm) {
        margin: 15px 0;
        font-size: 22px;
        line-height: 26px;
      }
    }
    .main-text {
      font-size: 16px;
      font-weight: 600;
      font-style: italic;
    }
    .page-text {
      font-size: 14px;
      font-weight: 500;
      color: #6c7781;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/TermsAndConditionsPage.vue